var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.inPreview,
            expression: "inPreview"
          }
        ],
        attrs: {
          inPreview: _vm.inPreview,
          generatingPreview: _vm.generatingPreview,
          saving: _vm.saving,
          pdfUrl: _vm.pdfUrl,
          backToForm: _vm.backToForm,
          save: _vm.save
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ]
        },
        [
          _c(
            "form",
            {
              staticClass: "mb-5",
              attrs: { autocomplete: "off" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("h2", [
                _vm._v(
                  " FORMULARIO SOLICITUD CONVENIO HONORARIOS " +
                    _vm._s(_vm.isDocenteForm ? " (DOCENTE)" : "") +
                    " " +
                    _vm._s(_vm.isNotDocenteForm ? " (NO DOCENTE)" : "") +
                    " "
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "formType" } }, [
                          _vm._v(" ¿Deseas basarte en otro documento? ")
                        ]),
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.createdDocuments,
                              name: "previousDocument",
                              label: "label",
                              "data-cy": "created-document-data",
                              clearable: true
                            },
                            on: {
                              input: function($event) {
                                return _vm.getDocumentData($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm.hasMoreDocuments
                                  ? {
                                      key: "list-footer",
                                      fn: function() {
                                        return [
                                          _c(
                                            "li",
                                            {
                                              staticClass: "text-center py-2",
                                              staticStyle: {
                                                "border-top":
                                                  "1px solid #e8e8e8"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#7367f0",
                                                    "font-weight": "500"
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.loadMoreDocuments(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.loadingMoreDocuments
                                                          ? "Cargando..."
                                                          : "Cargar más documentos"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.previousDocument,
                              callback: function($$v) {
                                _vm.previousDocument = $$v
                              },
                              expression: "previousDocument"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(" no hay documentos registrados ")
                            ])
                          ],
                          2
                        ),
                        _vm.$validator.errors.has("formType")
                          ? _c("v-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$validator.errors.first("formType")
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                !_vm.formData.formType
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "formType" } }, [
                              _vm._v(" Tipo de formulario "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("formType"))
                                }
                              })
                            ]),
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "v-select-danger": _vm.$validator.errors.has(
                                  "formType"
                                )
                              },
                              attrs: {
                                "data-cy": "formType",
                                name: "formType",
                                "data-vv-as": "tipo de formulario",
                                placeholder:
                                  "Por favor, selecciona un tipo de formulario",
                                state: _vm.$validator.errors.has("formType")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("formType"),
                                "danger-text": _vm.$validator.errors.first(
                                  "formType"
                                ),
                                selectable: function(opt) {
                                  return !opt.disabled
                                },
                                options: _vm.formTypeOptions,
                                clearable: true
                              },
                              model: {
                                value: _vm.formData.formType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "formType", $$v)
                                },
                                expression: "formData.formType"
                              }
                            }),
                            _vm.$validator.errors.has("formType")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("formType")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.formData.formType
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "vs-button",
                          {
                            staticClass: "w-100 mt-4",
                            attrs: {
                              size: "small",
                              color: "primary",
                              type: "border",
                              icon: "refresh"
                            },
                            on: {
                              click: function($event) {
                                return _vm.changeFormType()
                              }
                            }
                          },
                          [_vm._v(" Cambiar tipo de formulario ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(0),
                    _vm._m(1),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "fullName" } }, [
                              _vm._v(" Nombre completo "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("fullName"))
                                }
                              })
                            ]),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-cy": "fullName",
                                name: "fullName",
                                "data-vv-as": "nombre completo",
                                placeholder: "Nombre completo...",
                                state: _vm.$validator.errors.has("fullName")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("fullName"),
                                "danger-text": _vm.$validator.errors.first(
                                  "fullName"
                                )
                              },
                              model: {
                                value: _vm.formData.fullName,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "fullName", $$v)
                                },
                                expression: "formData.fullName"
                              }
                            }),
                            _vm.$validator.errors.has("fullName")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("fullName")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "rut" } }, [
                              _vm._v(" RUT "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("rut"))
                                }
                              })
                            ]),
                            _c("b-form-input-rut", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|validateRut",
                                  expression: "'required|validateRut'"
                                }
                              ],
                              attrs: {
                                "data-cy": "rut",
                                name: "rut",
                                "data-vv-as": "rut",
                                placeholder: "Ej: 12345678-9",
                                state: _vm.$validator.errors.has("rut")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("rut"),
                                "danger-text": _vm.$validator.errors.first(
                                  "rut"
                                )
                              },
                              model: {
                                value: _vm.formData.rut,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "rut", $$v)
                                },
                                expression: "formData.rut"
                              }
                            }),
                            _vm.$validator.errors.has("rut")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("rut")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "birthDate" } }, [
                              _vm._v(" Fecha de nacimiento "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("birthDate"))
                                }
                              })
                            ]),
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "w-100": true,
                                danger: _vm.$validator.errors.has("birthDate")
                              },
                              attrs: {
                                "data-cy": "birthDate",
                                name: "birthDate",
                                "data-vv-as": "fecha de nacimiento",
                                format: "DD/MM/YYYY",
                                "value-type": "DD/MM/YYYY",
                                placeholder: "Ej: 30/12/2000",
                                danger: _vm.$validator.errors.has("birthDate")
                              },
                              model: {
                                value: _vm.formData.birthDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "birthDate", $$v)
                                },
                                expression: "formData.birthDate"
                              }
                            }),
                            _vm.$validator.errors.has("birthDate")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("birthDate")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "address" } }, [
                              _vm._v(" Domicilio "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("address"))
                                }
                              })
                            ]),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-cy": "address",
                                name: "address",
                                "data-vv-as": "domicilio",
                                placeholder: "Domicilio...",
                                state: _vm.$validator.errors.has("address")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("address"),
                                "danger-text": _vm.$validator.errors.first(
                                  "address"
                                )
                              },
                              model: {
                                value: _vm.formData.address,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "address", $$v)
                                },
                                expression: "formData.address"
                              }
                            }),
                            _vm.$validator.errors.has("address")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("address")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "city" } }, [
                              _vm._v(" Ciudad "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("city"))
                                }
                              })
                            ]),
                            _c("v-select-city", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "city",
                                "data-cy": "city",
                                "data-vv-as": "ciudad",
                                state: _vm.$validator.errors.has("city")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("city"),
                                "danger-text": _vm.$validator.errors.first(
                                  "city"
                                )
                              },
                              model: {
                                value: _vm.formData.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "city", $$v)
                                },
                                expression: "formData.city"
                              }
                            }),
                            _vm.$validator.errors.has("city")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("city")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v(" Correo electrónico "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("email"))
                                }
                              })
                            ]),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              ref: "email",
                              attrs: {
                                type: "email",
                                "data-cy": "email",
                                name: "email",
                                "data-vv-as": "correo electrónico",
                                placeholder: "Correo electrónico...",
                                state: _vm.$validator.errors.has("email")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("email"),
                                "danger-text": _vm.$validator.errors.first(
                                  "email"
                                )
                              },
                              model: {
                                value: _vm.formData.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "email", $$v)
                                },
                                expression: "formData.email"
                              }
                            }),
                            _vm.$validator.errors.has("email")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("email")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "confirmEmail" } }, [
                              _vm._v(" Confirmación correo electrónico "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.required("confirmEmail")
                                  )
                                }
                              })
                            ]),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email|confirmed:email",
                                  expression: "'required|email|confirmed:email'"
                                }
                              ],
                              attrs: {
                                type: "email",
                                "data-cy": "confirmEmail",
                                name: "confirmEmail",
                                "data-vv-as":
                                  "confirmación de correo electrónico",
                                placeholder:
                                  "Por favor ingrese de nuevo el correo electrónico...",
                                state: _vm.$validator.errors.has("confirmEmail")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "confirmEmail"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "confirmEmail"
                                )
                              },
                              model: {
                                value: _vm.formData.confirmEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "confirmEmail", $$v)
                                },
                                expression: "formData.confirmEmail"
                              }
                            }),
                            _vm.$validator.errors.has("confirmEmail")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "confirmEmail"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "nationality" } }, [
                              _vm._v(" Nacionalidad "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("nationality"))
                                }
                              })
                            ]),
                            _c("v-select-nationality", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "nationality",
                                "data-cy": "nationality",
                                "data-vv-as": "nacionalidad",
                                state: _vm.$validator.errors.has("nationality")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "nationality"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "nationality"
                                )
                              },
                              model: {
                                value: _vm.formData.nationality,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "nationality", $$v)
                                },
                                expression: "formData.nationality"
                              }
                            }),
                            _vm.$validator.errors.has("nationality")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "nationality"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "isStudent" } }, [
                              _vm._v(" Estudiante "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("isStudent"))
                                }
                              })
                            ]),
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "v-select-danger": _vm.$validator.errors.has(
                                  "isStudent"
                                )
                              },
                              attrs: {
                                "data-cy": "isStudent",
                                name: "isStudent",
                                "data-vv-as": "estudiante",
                                placeholder: "Por favor, selecciona una opción",
                                state: _vm.$validator.errors.has("isStudent")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("isStudent"),
                                "danger-text": _vm.$validator.errors.first(
                                  "isStudent"
                                ),
                                selectable: function(opt) {
                                  return !opt.disabled
                                },
                                options: _vm.yesOrNoOptions
                              },
                              model: {
                                value: _vm.formData.isStudent,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isStudent", $$v)
                                },
                                expression: "formData.isStudent"
                              }
                            }),
                            _vm.$validator.errors.has("isStudent")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("isStudent")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "phoneNumber" } }, [
                              _vm._v(" Número telefónico "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("phoneNumber"))
                                }
                              })
                            ]),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                type: "tel",
                                "data-cy": "phoneNumber",
                                name: "phoneNumber",
                                "data-vv-as": "número telefónico",
                                placeholder: "Número telefónico...",
                                state: _vm.$validator.errors.has("phoneNumber")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "phoneNumber"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "phoneNumber"
                                )
                              },
                              model: {
                                value: _vm.formData.phoneNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "phoneNumber", $$v)
                                },
                                expression: "formData.phoneNumber"
                              }
                            }),
                            _vm.$validator.errors.has("phoneNumber")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "phoneNumber"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "institutionalEmail" } },
                              [
                                _vm._v(" Correo institucional "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("institutionalEmail")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              attrs: {
                                type: "tel",
                                "data-cy": "institutionalEmail",
                                name: "institutionalEmail",
                                "data-vv-as": "Correo institucional",
                                placeholder: "Correo institucional...",
                                state: _vm.$validator.errors.has(
                                  "institutionalEmail"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "institutionalEmail"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "institutionalEmail"
                                )
                              },
                              model: {
                                value: _vm.formData.institutionalEmail,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "institutionalEmail",
                                    $$v
                                  )
                                },
                                expression: "formData.institutionalEmail"
                              }
                            }),
                            _vm.$validator.errors.has("institutionalEmail")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "institutionalEmail"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(2),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "title" } }, [
                              _vm._v(" Título profesional/técnico "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("title"))
                                }
                              })
                            ]),
                            _c("v-select-title", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "title",
                                "data-cy": "title",
                                "data-vv-as": "título profesional/técnico",
                                state: _vm.$validator.errors.has("title")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("title"),
                                "danger-text": _vm.$validator.errors.first(
                                  "title"
                                )
                              },
                              model: {
                                value: _vm.formData.title,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "title", $$v)
                                },
                                expression: "formData.title"
                              }
                            }),
                            _vm.$validator.errors.has("title")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("title")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "university" } }, [
                              _vm._v(" Universidad u otra institución "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("university"))
                                }
                              })
                            ]),
                            _c("v-select-university", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "university",
                                "data-cy": "university",
                                "data-vv-as": "universidad u otra institución",
                                state: _vm.$validator.errors.has("university")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("university"),
                                "danger-text": _vm.$validator.errors.first(
                                  "university"
                                )
                              },
                              model: {
                                value: _vm.formData.university,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "university", $$v)
                                },
                                expression: "formData.university"
                              }
                            }),
                            _vm.$validator.errors.has("university")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "university"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "academicDegree" } }, [
                              _vm._v(" Grado Académico "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.required("academicDegree")
                                  )
                                }
                              })
                            ]),
                            _c("v-select-academic-degree", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "academicDegree",
                                "data-cy": "academicDegree",
                                "data-vv-as": "grado académico",
                                state: _vm.$validator.errors.has(
                                  "academicDegree"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "academicDegree"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "academicDegree"
                                )
                              },
                              model: {
                                value: _vm.formData.academicDegree,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "academicDegree", $$v)
                                },
                                expression: "formData.academicDegree"
                              }
                            }),
                            _vm.$validator.errors.has("academicDegree")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "academicDegree"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm.isNotDocenteForm
                      ? _c("div", { staticClass: "col-12 mb-2" }, [
                          _c("h5", [_vm._v("EXPERIENCIA Y/O EXPERTICIA")])
                        ])
                      : _vm._e(),
                    _vm.isNotDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "experience" } }, [
                                  _vm._v(" Experiencia "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("experience")
                                      )
                                    }
                                  })
                                ]),
                                _c("b-form-textarea", {
                                  attrs: {
                                    rows: "3",
                                    "data-cy": "experience",
                                    name: "experience",
                                    "data-vv-as": "experiencia",
                                    placeholder: "Experiencia...",
                                    state: _vm.$validator.errors.has(
                                      "experience"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "experience"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "experience"
                                    )
                                  },
                                  on: { input: _vm.validateAttachments },
                                  model: {
                                    value: _vm.formData.experience,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "experience", $$v)
                                    },
                                    expression: "formData.experience"
                                  }
                                }),
                                _vm.$validator.errors.has("experience")
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "experience"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.experience
                      ? _c(
                          "div",
                          { staticClass: "col-12 text-xs text-primary" },
                          [
                            _vm._v(
                              " Debe adjuntar un documento que acredite la "
                            ),
                            _c("b", [_vm._v("experiencia")])
                          ]
                        )
                      : _vm._e(),
                    _vm.isNotDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("file-list", {
                              attrs: { files: _vm.experienceFiles },
                              on: { "remove-file": _vm.removeExperienceFile }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.experience && !_vm.experienceFiles.length
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "has-permission",
                                    rawName: "v-has-permission",
                                    value: "ED060",
                                    expression: "'ED060'"
                                  },
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal",
                                    value: "add-repository-experience-file",
                                    expression:
                                      "'add-repository-experience-file'"
                                  }
                                ],
                                staticClass: "btn-icon mt-1 w-100",
                                attrs: {
                                  variant: "primary",
                                  "data-cy": "from-repository",
                                  disabled:
                                    _vm.experienceFiles.length >=
                                    _vm.maxExperienceFiles
                                }
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "ServerIcon" }
                                }),
                                _vm._v(" Seleccionar desde repositorio ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.experience && !_vm.experienceFiles.length
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("upload-file", {
                              attrs: {
                                color: "primary",
                                permission: "*",
                                accept:
                                  "application/pdf, .doc, .docx, .xlsv, .ppt",
                                text: "Seleccionar desde su dispositivo",
                                "data-cy": "uploadFile",
                                "upload-to": "ed",
                                "button-class": "btn-block",
                                "container-class": "w-100"
                              },
                              on: { input: _vm.addExperienceFile },
                              model: {
                                value: _vm.experienceFile,
                                callback: function($$v) {
                                  _vm.experienceFile = $$v
                                },
                                expression: "experienceFile"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.experienceFileError
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("v-invalid-feedback", [
                              _vm._v(
                                " " + _vm._s(_vm.experienceFileError) + " "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isNotDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12 mt-4" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "expertise" } }, [
                                  _vm._v(" Experticia "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("expertise")
                                      )
                                    }
                                  })
                                ]),
                                _c("b-form-textarea", {
                                  attrs: {
                                    rows: "3",
                                    "data-cy": "expertise",
                                    name: "expertise",
                                    "data-vv-as": "experticia",
                                    placeholder: "Experticia...",
                                    state: _vm.$validator.errors.has(
                                      "expertise"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "expertise"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "expertise"
                                    )
                                  },
                                  on: { input: _vm.validateAttachments },
                                  model: {
                                    value: _vm.formData.expertise,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "expertise", $$v)
                                    },
                                    expression: "formData.expertise"
                                  }
                                }),
                                _vm.$validator.errors.has("expertise")
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "expertise"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.experience
                      ? _c(
                          "div",
                          { staticClass: "col-12 text-xs text-primary" },
                          [
                            _vm._v(
                              " Debe adjuntar un documento que acredite la "
                            ),
                            _c("b", [_vm._v("experticia")])
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("file-list", {
                          attrs: { files: _vm.expertiseFiles },
                          on: { "remove-file": _vm.removeExpertiseFile }
                        })
                      ],
                      1
                    ),
                    _vm.formData.expertise && !_vm.expertiseFiles.length
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "has-permission",
                                    rawName: "v-has-permission",
                                    value: "ED060",
                                    expression: "'ED060'"
                                  },
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal",
                                    value: "add-repository-expertise-file",
                                    expression:
                                      "'add-repository-expertise-file'"
                                  }
                                ],
                                staticClass: "btn-icon mt-1 w-100",
                                attrs: {
                                  variant: "primary",
                                  "data-cy": "from-repository",
                                  disabled:
                                    _vm.expertiseFiles.length >=
                                    _vm.maxExpertiseFiles
                                }
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "ServerIcon" }
                                }),
                                _vm._v(" Seleccionar desde repositorio ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.expertise && !_vm.expertiseFiles.length
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("upload-file", {
                              attrs: {
                                color: "primary",
                                permission: "*",
                                accept:
                                  "application/pdf, .doc, .docx, .xlsv, .ppt",
                                text: "Seleccionar desde su dispositivo",
                                "data-cy": "uploadFile",
                                "upload-to": "ed",
                                "button-class": "btn-block",
                                "container-class": "w-100"
                              },
                              on: { input: _vm.addExpertiseFile },
                              model: {
                                value: _vm.expertiseFile,
                                callback: function($$v) {
                                  _vm.expertiseFile = $$v
                                },
                                expression: "expertiseFile"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.expertiseFileError
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("v-invalid-feedback", [
                              _vm._v(" " + _vm._s(_vm.expertiseFileError) + " ")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isNotDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [_c("vs-divider")],
                          1
                        )
                      : _vm._e(),
                    _vm._m(3),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "healthInsurance" } }, [
                              _vm._v(" Seguro de salud (ISAPRE/FONASA) "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.required("healthInsurance")
                                  )
                                }
                              })
                            ]),
                            _c("v-select-isapres", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "healthInsurance",
                                "data-cy": "healthInsurance",
                                "data-vv-as": "seguro de salud",
                                state: _vm.$validator.errors.has(
                                  "healthInsurance"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "healthInsurance"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "healthInsurance"
                                ),
                                "include-fonasa": ""
                              },
                              model: {
                                value: _vm.formData.healthInsurance,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "healthInsurance", $$v)
                                },
                                expression: "formData.healthInsurance"
                              }
                            }),
                            _vm.$validator.errors.has("healthInsurance")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "healthInsurance"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "afp" } }, [
                              _vm._v(" AFP "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("afp"))
                                }
                              })
                            ]),
                            _c("v-select-afps", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "afp",
                                "data-cy": "afp",
                                "data-vv-as": "afp",
                                state: _vm.$validator.errors.has("afp")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("afp"),
                                "danger-text": _vm.$validator.errors.first(
                                  "afp"
                                )
                              },
                              model: {
                                value: _vm.formData.afp,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "afp", $$v)
                                },
                                expression: "formData.afp"
                              }
                            }),
                            _vm.$validator.errors.has("afp")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("afp")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm.isDocenteForm
                      ? _c("div", { staticClass: "col-12 mb-2" }, [
                          _c("h5", [_vm._v("HORAS DE TRABAJO Y REMUNERACIÓN")])
                        ])
                      : _vm._e(),
                    _vm.isNotDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("vs-table", {
                              staticClass: "wrap-table shadow",
                              attrs: {
                                hoverFlat: "",
                                data: _vm.formData.associatedProduct || [],
                                noDataText: "No hay actividades aún"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var data = ref.data
                                      return [
                                        _c("thead", [
                                          _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                " Productos y servicios asociados "
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "tbody",
                                          _vm._l(data, function(_, idx) {
                                            return _c(
                                              "vs-tr",
                                              { key: idx },
                                              [
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "table-part",
                                                    attrs: { data: data[idx] }
                                                  },
                                                  [
                                                    _c(
                                                      "b-row",
                                                      {
                                                        ref:
                                                          "associatedProduct[" +
                                                          idx +
                                                          "].row",
                                                        refInFor: true,
                                                        staticClass:
                                                          "border mx-1 my-2 py-4"
                                                      },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].product"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Servicio/Producto "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "associatedProduct[" +
                                                                              idx +
                                                                              "].product"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows: "2",
                                                                      name:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].product",
                                                                      "data-cy":
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].product",
                                                                      "data-vv-as":
                                                                        "servicio/producto",
                                                                      placeholder:
                                                                        "Servicio/Producto...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].product"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].product"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].product"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .product,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "product",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].product"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "associatedProduct[" +
                                                                    idx +
                                                                    "].product"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "associatedProduct[" +
                                                                                  idx +
                                                                                  "].product"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].subproduct"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Medio de verificación o subproducto "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "associatedProduct[" +
                                                                              idx +
                                                                              "].subproduct"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows: "2",
                                                                      name:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].subproduct",
                                                                      "data-cy":
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].subproduct",
                                                                      "data-vv-as":
                                                                        "medio de verificación o subproducto",
                                                                      placeholder:
                                                                        "Medio de verificación o subproducto...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].subproduct"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].subproduct"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].subproduct"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .subproduct,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "subproduct",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].subproduct"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "associatedProduct[" +
                                                                    idx +
                                                                    "].subproduct"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "associatedProduct[" +
                                                                                  idx +
                                                                                  "].subproduct"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].period"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Periodo "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "associatedProduct[" +
                                                                              idx +
                                                                              "].period"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-select-period",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      parent:
                                                                        _vm.$vnode,
                                                                      name:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].period",
                                                                      "data-cy":
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].period",
                                                                      "data-vv-as":
                                                                        "periodo",
                                                                      state: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].period"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].period"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].period"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .period,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "period",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].period"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "associatedProduct[" +
                                                                    idx +
                                                                    "].period"
                                                                )
                                                                  ? _c(
                                                                      "v-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "associatedProduct[" +
                                                                                  idx +
                                                                                  "].period"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].bruteValuation"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Valorización bruta "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "associatedProduct[" +
                                                                              idx +
                                                                              "].bruteValuation"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "input-currency",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "mb-0",
                                                                    attrs: {
                                                                      label: "",
                                                                      options:
                                                                        _vm.currencyInputOptions,
                                                                      name:
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].bruteValuation",
                                                                      "data-cy":
                                                                        "associatedProduct[" +
                                                                        idx +
                                                                        "].bruteValuation",
                                                                      "data-vv-as":
                                                                        "valorización bruta",
                                                                      placeholder:
                                                                        "Valorización bruta...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].bruteValuation"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].bruteValuation"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "associatedProduct[" +
                                                                          idx +
                                                                          "].bruteValuation"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .bruteValuation,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "bruteValuation",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].bruteValuation"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "associatedProduct[" +
                                                                    idx +
                                                                    "].bruteValuation"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "associatedProduct[" +
                                                                                  idx +
                                                                                  "].bruteValuation"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: {
                                                              cols:
                                                                "12 d-flex justify-content-end"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "vs-button",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "danger",
                                                                  type:
                                                                    "border",
                                                                  icon: "delete"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeAssociatedProductRow(
                                                                      idx
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Eliminar fila "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        ),
                                        _c(
                                          "tfoot",
                                          [
                                            _c(
                                              "vs-tr",
                                              [
                                                _c(
                                                  "vs-td",
                                                  { attrs: { colspan: "3" } },
                                                  [
                                                    _c(
                                                      "vs-button",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          color: "primary",
                                                          type: "border",
                                                          icon: "add"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.addAssociatedProductRow
                                                        }
                                                      },
                                                      [_vm._v(" Agregar fila ")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                486293578
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("vs-table", {
                              staticClass: "wrap-table shadow",
                              attrs: {
                                hoverFlat: "",
                                data:
                                  _vm.formData.workHoursAndRemuneration || [],
                                noDataText: "No hay actividades aún"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var data = ref.data
                                      return [
                                        _c("thead", [
                                          _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                "Horas de trabajo y remuneración"
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "tbody",
                                          _vm._l(data, function(_, idx) {
                                            return _c(
                                              "vs-tr",
                                              { key: idx },
                                              [
                                                _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "table-part",
                                                    attrs: { data: data[idx] }
                                                  },
                                                  [
                                                    _c(
                                                      "b-row",
                                                      {
                                                        ref:
                                                          "workHoursAndRemuneration[" +
                                                          idx +
                                                          "].row",
                                                        refInFor: true,
                                                        staticClass:
                                                          "border mx-1 my-2 py-4"
                                                      },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subject"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Asignatura "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].subject"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-select-subject",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      parent:
                                                                        _vm.$vnode,
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subject",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subject",
                                                                      "data-vv-as":
                                                                        "asignatura",
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].subject"
                                                                      ),
                                                                      "label-with-code":
                                                                        ""
                                                                    },
                                                                    on: {
                                                                      "full-input": function(
                                                                        e
                                                                      ) {
                                                                        return _vm.setSubject(
                                                                          e,
                                                                          idx
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .subject,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "subject",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].subject"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].subject"
                                                                )
                                                                  ? _c(
                                                                      "v-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].subject"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subject"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Carrera "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].subject"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-select-career",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      parent:
                                                                        _vm.$vnode,
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subjectCareer",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subjectCareer",
                                                                      "data-vv-as":
                                                                        "carrera",
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].subjectCareer"
                                                                      ),
                                                                      "label-with-code":
                                                                        ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .subjectCareer,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "subjectCareer",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].subjectCareer"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].subjectCareer"
                                                                )
                                                                  ? _c(
                                                                      "v-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].subjectCareer"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].headOfCareer"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Jefe De Carrera "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].headOfCareer"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-select-head-of-career",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      parent:
                                                                        _vm.$vnode,
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].headOfCareer",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].headOfCareer",
                                                                      "data-vv-as":
                                                                        "jefe de carrera",
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].headOfCareer"
                                                                      ),
                                                                      "label-with-code":
                                                                        ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .headOfCareer,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "headOfCareer",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].headOfCareer"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].headOfCareer"
                                                                )
                                                                  ? _c(
                                                                      "v-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].headOfCareer"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].docentHours"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " N° horas docentes "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].docentHours"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isDocentHoursRequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.docentHoursMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{ required: isDocentHoursRequired(idx), min_value: docentHoursMinValue(idx) }"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "number",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].docentHours",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].docentHours",
                                                                      "data-vv-as":
                                                                        "n° horas docentes",
                                                                      placeholder:
                                                                        "N° horas docentes...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].docentHours"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].docentHours"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].docentHours"
                                                                      ),
                                                                      min: "0"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .docentHours,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "docentHours",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].docentHours"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].docentHours"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].docentHours"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountA"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Monto hora docente colaborador (horas docentes) "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].collaboratorDocentHourAmountA"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "input-currency",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isCollaboratorDocentHourAmountARequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.colaboratorDocentHourAmountAMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{ required: isCollaboratorDocentHourAmountARequired(idx), min_value: colaboratorDocentHourAmountAMinValue(idx) }"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "mb-0",
                                                                    attrs: {
                                                                      label: "",
                                                                      placeholder:
                                                                        "Ingresa un monto...",
                                                                      options:
                                                                        _vm.currencyInputOptions,
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountA",
                                                                      "data-vv-as":
                                                                        "monto hora docente colaborador (horas docentes)",
                                                                      id:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountA",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountA",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountA"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountA"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountA"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .collaboratorDocentHourAmountA,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "collaboratorDocentHourAmountA",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].collaboratorDocentHourAmountA"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].collaboratorDocentHourAmountA"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].collaboratorDocentHourAmountA"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorA"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Factor (horas docentes) "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].factorA"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isFactorARequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.factorAMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{\n                          required: isFactorARequired(idx),\n                          min_value: factorAMinValue(idx),\n                        }"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "number",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorA",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorA",
                                                                      "data-vv-as":
                                                                        "factor",
                                                                      placeholder:
                                                                        "Factor...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorA"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorA"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorA"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .factorA,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "factorA",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].factorA"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].factorA"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].factorA"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalA"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Subtotal (horas docentes) "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalA",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalA",
                                                                      "data-vv-as":
                                                                        "subtotal",
                                                                      placeholder:
                                                                        "Producto datos anteriores..."
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .subtotalA,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "subtotalA",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].subtotalA"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { cols: "6" }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].otherActivitiesHours"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " N° horas otras actividades "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].otherActivitiesHours"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isOtherActivitiesHoursRequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.otherActivitiesHoursMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{required: isOtherActivitiesHoursRequired(idx), min_value: otherActivitiesHoursMinValue(idx)}"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "number",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].otherActivitiesHours",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].otherActivitiesHours",
                                                                      "data-vv-as":
                                                                        "n° horas otras actividades",
                                                                      placeholder:
                                                                        "N° horas otras actividades...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].otherActivitiesHours"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].otherActivitiesHours"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].otherActivitiesHours"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .workHoursAndRemuneration[
                                                                          idx
                                                                        ]
                                                                          .otherActivitiesHours,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .workHoursAndRemuneration[
                                                                            idx
                                                                          ],
                                                                          "otherActivitiesHours",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "formData.workHoursAndRemuneration[idx].otherActivitiesHours"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].otherActivitiesHours"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].otherActivitiesHours"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountB"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Monto hora docente colaborador (otras actividades) "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].collaboratorDocentHourAmountB"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "input-currency",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isCollaboratorDocentHourAmountBRequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.colaboratorDocentHourAmountBMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{required: isCollaboratorDocentHourAmountBRequired(idx), min_value: colaboratorDocentHourAmountBMinValue(idx)}"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "mb-0",
                                                                    attrs: {
                                                                      label: "",
                                                                      placeholder:
                                                                        "Ingresa un monto...",
                                                                      options:
                                                                        _vm.currencyInputOptions,
                                                                      id:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountB",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountB",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].collaboratorDocentHourAmountB",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountB"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountB"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].collaboratorDocentHourAmountB"
                                                                      ),
                                                                      "data-vv-as":
                                                                        "monto hora docente colaborador (otras actividades)"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .collaboratorDocentHourAmountB,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "collaboratorDocentHourAmountB",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].collaboratorDocentHourAmountB"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].collaboratorDocentHourAmountB"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].collaboratorDocentHourAmountB"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorB"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Factor (otras actividades) "
                                                                    ),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.required(
                                                                            "workHoursAndRemuneration[" +
                                                                              idx +
                                                                              "].factorB"
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value: {
                                                                          required: _vm.isFactorBRequired(
                                                                            idx
                                                                          ),
                                                                          min_value: _vm.factorBMinValue(
                                                                            idx
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "{required: isFactorBRequired(idx), min_value: factorBMinValue(idx)}"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "number",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorB",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].factorB",
                                                                      "data-vv-as":
                                                                        "factor",
                                                                      placeholder:
                                                                        "Factor...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorB"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorB"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "workHoursAndRemuneration[" +
                                                                          idx +
                                                                          "].factorB"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .workHoursAndRemuneration[
                                                                          idx
                                                                        ]
                                                                          .factorB,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .workHoursAndRemuneration[
                                                                            idx
                                                                          ],
                                                                          "factorB",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "formData.workHoursAndRemuneration[idx].factorB"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "workHoursAndRemuneration[" +
                                                                    idx +
                                                                    "].factorB"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "workHoursAndRemuneration[" +
                                                                                  idx +
                                                                                  "].factorB"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-form-group",
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    attrs: {
                                                                      for:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalB"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Subtotal (otras actividades) "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      "data-cy":
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalB",
                                                                      name:
                                                                        "workHoursAndRemuneration[" +
                                                                        idx +
                                                                        "].subtotalB",
                                                                      "data-vv-as":
                                                                        "subtotal",
                                                                      placeholder:
                                                                        "Producto datos anteriores..."
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .subtotalB,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "subtotalB",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].subtotalB"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: {
                                                              cols:
                                                                "12 d-flex justify-content-end"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "vs-button",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "danger",
                                                                  type:
                                                                    "border",
                                                                  icon: "delete"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeWorkHoursAndRemunerationRow(
                                                                      idx
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Eliminar fila "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        ),
                                        _c(
                                          "tfoot",
                                          [
                                            _c(
                                              "vs-tr",
                                              [
                                                _c(
                                                  "vs-td",
                                                  { attrs: { colspan: "3" } },
                                                  [
                                                    _c(
                                                      "vs-button",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          color: "primary",
                                                          type: "border",
                                                          icon: "add"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.addWorkHoursAndRemunerationRow
                                                        }
                                                      },
                                                      [_vm._v(" Agregar fila ")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "vs-tr",
                                              [
                                                _c(
                                                  "vs-td",
                                                  { attrs: { colspan: "3" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "serviceHours"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Horas de servicios "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-xs text-muted"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (Suma de todas las horas docentes y otras actividades) "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            disabled: "",
                                                            type: "number",
                                                            "data-cy":
                                                              "serviceHours",
                                                            name:
                                                              "serviceHours",
                                                            "data-vv-as":
                                                              "horas de servicios",
                                                            placeholder:
                                                              "Suma de horas docentes y otras actividades...",
                                                            state: _vm.$validator.errors.has(
                                                              "serviceHours"
                                                            )
                                                              ? false
                                                              : null,
                                                            danger: _vm.$validator.errors.has(
                                                              "serviceHours"
                                                            ),
                                                            "danger-text": _vm.$validator.errors.first(
                                                              "serviceHours"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .serviceHours,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "serviceHours",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.serviceHours"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3306249341
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12 mt-10" },
                          [
                            _c(
                              "vs-table",
                              {
                                staticClass: "wrap-table shadow",
                                attrs: {
                                  hoverFlat: "",
                                  data: _vm.formData.schedules || [],
                                  noDataText: "No hay horarios aún"
                                }
                              },
                              [
                                [
                                  _c("thead", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "3" }
                                      },
                                      [_vm._v(" Horarios ")]
                                    )
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.formData.schedules, function(
                                      _,
                                      index
                                    ) {
                                      return _c(
                                        "vs-tr",
                                        { key: index },
                                        [
                                          _c(
                                            "vs-td",
                                            { staticClass: "table-part" },
                                            [
                                              _c(
                                                "b-form-group",
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "day" } },
                                                    [
                                                      _vm._v(
                                                        " Día de la semana "
                                                      ),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.required(
                                                              "schedules[" +
                                                                index +
                                                                "].day"
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c("v-select", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    class: {
                                                      "v-select-danger": _vm.$validator.errors.has(
                                                        "schedules[" +
                                                          index +
                                                          "].day"
                                                      )
                                                    },
                                                    attrs: {
                                                      "data-cy":
                                                        "schedules[" +
                                                        index +
                                                        "].day",
                                                      name:
                                                        "schedules[" +
                                                        index +
                                                        "].day",
                                                      "data-vv-as": "fecha",
                                                      placeholder:
                                                        "Día de la semana...",
                                                      state: _vm.$validator.errors.has(
                                                        "schedules[" +
                                                          index +
                                                          "].day"
                                                      )
                                                        ? false
                                                        : null,
                                                      danger: _vm.$validator.errors.has(
                                                        "schedules[" +
                                                          index +
                                                          "].day"
                                                      ),
                                                      "danger-text": _vm.$validator.errors.first(
                                                        "schedules[" +
                                                          index +
                                                          "].day"
                                                      ),
                                                      options:
                                                        _vm.weekDayOptions
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formData.schedules[
                                                          index
                                                        ].day,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.formData
                                                            .schedules[index],
                                                          "day",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.schedules[index].day"
                                                    }
                                                  }),
                                                  _vm.$validator.errors.has(
                                                    "schedules[" +
                                                      index +
                                                      "].day"
                                                  )
                                                    ? _c("v-invalid-feedback", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$validator.errors.first(
                                                                "schedules[" +
                                                                  index +
                                                                  "].day"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-td",
                                            [
                                              _c(
                                                "b-form-group",
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "hour" } },
                                                    [
                                                      _vm._v(" Hora "),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.required(
                                                              "schedules[" +
                                                                index +
                                                                "].hour"
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c(
                                                    "date-picker",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value:
                                                            "required|requiredTime",
                                                          expression:
                                                            "'required|requiredTime'"
                                                        }
                                                      ],
                                                      class: {
                                                        "w-100": true,
                                                        danger: _vm.$validator.errors.has(
                                                          "schedules[" +
                                                            index +
                                                            "].hour"
                                                        )
                                                      },
                                                      attrs: {
                                                        type: "time",
                                                        "data-cy":
                                                          "schedules[" +
                                                          index +
                                                          "].hour",
                                                        name:
                                                          "schedules[" +
                                                          index +
                                                          "].hour",
                                                        "data-vv-as": "hora",
                                                        placeholder: "Hora...",
                                                        format: "HH:mm",
                                                        "show-second": false,
                                                        "value-type": "format",
                                                        danger: _vm.$validator.errors.has(
                                                          "schedules[" +
                                                            index +
                                                            "].hour"
                                                        ),
                                                        range: ""
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.validateSchedulesServiceHours
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formData
                                                            .schedules[index]
                                                            .hour,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formData
                                                              .schedules[index],
                                                            "hour",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formData.schedules[index].hour"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        { slot: "header" },
                                                        [
                                                          _c(
                                                            "table",
                                                            {
                                                              staticClass:
                                                                "w-100"
                                                            },
                                                            [
                                                              _c("tr", [
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    staticClass:
                                                                      "w-50 text-center border-right-header"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Inicio "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    staticClass:
                                                                      "text-center"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Fin "
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  ),
                                                  _vm.$validator.errors.has(
                                                    "schedules[" +
                                                      index +
                                                      "].hour"
                                                  )
                                                    ? _c("v-invalid-feedback", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$validator.errors.first(
                                                                "schedules[" +
                                                                  index +
                                                                  "].hour"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-td",
                                            { staticClass: "align-middle" },
                                            [
                                              _c("vs-button", {
                                                staticClass: "-mb-3",
                                                attrs: {
                                                  color: "danger",
                                                  type: "border",
                                                  icon: "delete"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeSchedule(
                                                      index
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                  _c(
                                    "tfoot",
                                    [
                                      _c(
                                        "vs-tr",
                                        [
                                          _c(
                                            "vs-td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _c(
                                                "vs-button",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    color: "primary",
                                                    type: "border",
                                                    icon: "add"
                                                  },
                                                  on: { click: _vm.addSchedule }
                                                },
                                                [_vm._v(" Agregar horario ")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "vs-tr",
                                        [
                                          _c(
                                            "vs-td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _vm.schedulesServiceHoursError
                                                ? _c(
                                                    "v-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        "data-cy":
                                                          "schedulesServiceHoursError"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.schedulesServiceHoursError
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(4),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "contractValidityDate" } },
                              [
                                _vm._v(" Vigencia del Contrato "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("contractValidityDate")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|requiredDateRange",
                                  expression: "'required|requiredDateRange'"
                                }
                              ],
                              staticClass: "w-100",
                              class: {
                                "w-100": true,
                                danger: _vm.$validator.errors.has(
                                  "contractValidityDate"
                                )
                              },
                              attrs: {
                                "data-cy": "contractValidityDate",
                                name: "contractValidityDate",
                                "data-vv-as": "vigencia del contrato",
                                format: "DD/MM/YYYY",
                                "value-type": "DD/MM/YYYY",
                                placeholder: "03/12/2024 ~ 19/12/2024",
                                danger: _vm.$validator.errors.has(
                                  "contractValidityDate"
                                ),
                                range: ""
                              },
                              model: {
                                value: _vm.formData.contractValidityDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "contractValidityDate",
                                    $$v
                                  )
                                },
                                expression: "formData.contractValidityDate"
                              }
                            }),
                            _vm.$validator.errors.has("contractValidityDate")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "contractValidityDate"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _vm.formData.contractValidityDate[0] &&
                            _vm.formData.contractValidityDate[1]
                              ? _c("small", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formData.contractValidityDateText
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._m(5),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "administrativeResponsible" } },
                              [
                                _vm._v(" Responsable administrativo "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("administrativeResponsible")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("list-user", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-1",
                              attrs: {
                                label: "",
                                autocomplete: "",
                                name: "administrativeResponsible",
                                "data-cy": "administrativeResponsible",
                                "data-vv-as": "responsable administrativo",
                                state: _vm.$validator.errors.has(
                                  "administrativeResponsible"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "administrativeResponsible"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "administrativeResponsible"
                                )
                              },
                              on: {
                                "full-user": function($event) {
                                  _vm.formData.administrativeResponsibleComplete = $event
                                }
                              },
                              model: {
                                value: _vm.formData.administrativeResponsible,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "administrativeResponsible",
                                    $$v
                                  )
                                },
                                expression: "formData.administrativeResponsible"
                              }
                            }),
                            _vm.$validator.errors.has(
                              "administrativeResponsible"
                            )
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "administrativeResponsible"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                " Firmante (Responsable administrativo/a)*: Persona que formaliza la solicitud mediante su firma, asumiendo la responsabilidad administrativa correspondiente. Esta designación quedará registrada en el convenio. Será la única persona autorizada para firmar los informes de actividades. "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "administrativeResponsiblePosition"
                                }
                              },
                              [
                                _vm._v(" Cargo responsable administrativo "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required(
                                        "administrativeResponsiblePosition"
                                      )
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-cy": "administrativeResponsiblePosition",
                                name: "administrativeResponsiblePosition",
                                "data-vv-as":
                                  "cargo responsable administrativo",
                                placeholder:
                                  "Cargo responsable administrativo...",
                                state: _vm.$validator.errors.has(
                                  "administrativeResponsiblePosition"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "administrativeResponsiblePosition"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "administrativeResponsiblePosition"
                                )
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .administrativeResponsiblePosition,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "administrativeResponsiblePosition",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.administrativeResponsiblePosition"
                              }
                            }),
                            _vm.$validator.errors.has(
                              "administrativeResponsiblePosition"
                            )
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "administrativeResponsiblePosition"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "administrativeSupport" } },
                              [
                                _vm._v(" Soporte administrativo "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("administrativeSupport")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("list-user", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-1",
                              attrs: {
                                label: "",
                                autocomplete: "",
                                name: "administrativeSupport",
                                "data-cy": "administrativeSupport",
                                "data-vv-as": "soporte administrativo",
                                state: _vm.$validator.errors.has(
                                  "administrativeSupport"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "administrativeSupport"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "administrativeSupport"
                                )
                              },
                              on: {
                                "full-user": function($event) {
                                  _vm.formData.administrativeSupportComplete = $event
                                }
                              },
                              model: {
                                value: _vm.formData.administrativeSupport,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "administrativeSupport",
                                    $$v
                                  )
                                },
                                expression: "formData.administrativeSupport"
                              }
                            }),
                            _vm.$validator.errors.has("administrativeSupport")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "administrativeSupport"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                " Verifica que los documentos estén completos, correctos y que se cumplan los requisitos formales para la tramitación. "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              {
                                attrs: { for: "otherResponsiblesCompleteNew" }
                              },
                              [
                                _vm._v(" Visador de Actividades "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("otherResponsiblesComplete")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("list-user", {
                              attrs: {
                                label: "",
                                options: _vm.users,
                                name: "otherResponsiblesCompleteNew",
                                "data-cy": "otherResponsiblesCompleteNew",
                                "data-vv-as": "visador de actividades",
                                placeholder: "Visador de Actividades...",
                                state: _vm.$validator.errors.has(
                                  "otherResponsiblesCompleteNew"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "otherResponsiblesCompleteNew"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "otherResponsiblesCompleteNew"
                                )
                              },
                              on: {
                                "full-user": function($event) {
                                  _vm.formData.otherResponsibleComplete = $event
                                }
                              },
                              model: {
                                value:
                                  _vm.formData.otherResponsiblesCompleteNew,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "otherResponsiblesCompleteNew",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.otherResponsiblesCompleteNew"
                              }
                            }),
                            _vm.$validator.errors.has(
                              "otherResponsiblesCompleteNew"
                            )
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "otherResponsiblesCompleteNew"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                " Persona encargada de revisar y validar los productos entregables y/o las funciones realizadas durante el periodo correspondiente al informe de actividades, conforme a lo establecido en el convenio. "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 mt-5" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "specificLaborArray" } },
                              [
                                _vm._v(
                                  " Indicar detalladamente la(s) labor(es) específica(s) que desempeñará la persona contratada "
                                ),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("administrativeResponsible")
                                    )
                                  }
                                }),
                                _c("br"),
                                _c("span", { staticClass: "text-xs mt-1" }, [
                                  _vm._v(
                                    " (En la redacción del convenio se utilizará esta misma información) "
                                  )
                                ])
                              ]
                            ),
                            _vm._l(_vm.formData.specificLaborArray, function(
                              task,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: "task-" + index, staticClass: "row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-9 mt-3" },
                                    [
                                      _c("b-form-textarea", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|min:1|max:560",
                                            expression:
                                              "'required|min:1|max:560'"
                                          }
                                        ],
                                        attrs: {
                                          rows: "2",
                                          "data-cy": "specificLaborArray",
                                          name: "specificLaborArray",
                                          "data-vv-as": "labor específica",
                                          placeholder: "Labor específica...",
                                          state: _vm.$validator.errors.has(
                                            "specificLaborArray"
                                          )
                                            ? false
                                            : null,
                                          maxlength: 560,
                                          danger: _vm.$validator.errors.has(
                                            "specificLaborArray"
                                          ),
                                          "danger-text": _vm.$validator.errors.first(
                                            "specificLaborArray"
                                          )
                                        },
                                        model: {
                                          value: task.task,
                                          callback: function($$v) {
                                            _vm.$set(task, "task", $$v)
                                          },
                                          expression: "task.task"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "form-text text-muted text-right"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                task.task ? task.task.length : 0
                                              ) +
                                              " / 560 "
                                          )
                                        ]
                                      ),
                                      _vm.$validator.errors.has(
                                        "specificLaborArray"
                                      )
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$validator.errors.first(
                                                    "specificLaborArray"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "col-md-3 mt-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "vs-button",
                                          {
                                            attrs: {
                                              color: "danger",
                                              type: "border",
                                              icon: "delete"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeTask(index)
                                              }
                                            }
                                          },
                                          [_vm._v(" Eliminar fila ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            }),
                            _c(
                              "div",
                              { staticClass: "text-right mt-5" },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "w-100",
                                    attrs: {
                                      color: "primary",
                                      type: "border",
                                      icon: "add"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addNewTask()
                                      }
                                    }
                                  },
                                  [_vm._v(" Agregar fila ")]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "groupBelongsUser" } },
                              [
                                _vm._v(
                                  " Unidad Organizativa en la que se desempeña "
                                ),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("groupBelongsUser")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "v-select-danger": _vm.$validator.errors.has(
                                  "groupBelongsUser"
                                )
                              },
                              attrs: {
                                name: "groupBelongsUser",
                                "data-cy": "groupBelongsUser",
                                "data-vv-as": "unidad organizativa",
                                placeholder:
                                  "Seleccione una unidad organizativa",
                                options: _vm.companyGroups,
                                loading: _vm.loadingGroups,
                                label: "nombre",
                                state: _vm.$validator.errors.has(
                                  "groupBelongsUser"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "groupBelongsUser"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "groupBelongsUser"
                                )
                              },
                              on: { input: _vm.onGroupSelected },
                              model: {
                                value: _vm.formData.groupBelongsUser,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "groupBelongsUser",
                                    $$v
                                  )
                                },
                                expression: "formData.groupBelongsUser"
                              }
                            }),
                            _vm.$validator.errors.has("groupBelongsUser")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "groupBelongsUser"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(6),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "bank" } }, [
                              _vm._v(" Banco "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("bank"))
                                }
                              })
                            ]),
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "v-select-danger": _vm.$validator.errors.has(
                                  "bank"
                                )
                              },
                              attrs: {
                                "data-cy": "bank",
                                name: "bank",
                                "data-vv-as": "banco",
                                placeholder: _vm.bankLoadingText,
                                options: _vm.bankOptions,
                                loading: _vm.loadingBankOptions,
                                disabled: _vm.loadingBankOptions,
                                label: "text",
                                reduce: function(opt) {
                                  return opt.value
                                },
                                state: _vm.$validator.errors.has("bank")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("bank"),
                                "danger-text": _vm.$validator.errors.first(
                                  "bank"
                                )
                              },
                              model: {
                                value: _vm.formData.bank,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "bank", $$v)
                                },
                                expression: "formData.bank"
                              }
                            }),
                            _vm.$validator.errors.has("bank")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first("bank")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "bankAccountType" } }, [
                              _vm._v(" Tipo de cuenta "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.required("bankAccountType")
                                  )
                                }
                              })
                            ]),
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "v-select-danger": _vm.$validator.errors.has(
                                  "bankAccountType"
                                )
                              },
                              attrs: {
                                "data-cy": "bankAccountType",
                                name: "bankAccountType",
                                "data-vv-as": "tipo de cuenta",
                                placeholder:
                                  "-- Selecciona un tipo de cuenta --",
                                options: _vm.bankAccountTypes,
                                state: _vm.$validator.errors.has(
                                  "bankAccountType"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "bankAccountType"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "bankAccountType"
                                )
                              },
                              model: {
                                value: _vm.formData.bankAccountType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "bankAccountType", $$v)
                                },
                                expression: "formData.bankAccountType"
                              }
                            }),
                            _vm.$validator.errors.has("bankAccountType")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "bankAccountType"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "bankAccountNumber" } },
                              [
                                _vm._v(" N° de cuenta "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("bankAccountNumber")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-cy": "bankAccountNumber",
                                name: "bankAccountNumber",
                                "data-vv-as": "número de cuenta",
                                placeholder: "N° de cuenta...",
                                state: _vm.$validator.errors.has(
                                  "bankAccountNumber"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "bankAccountNumber"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "bankAccountNumber"
                                )
                              },
                              model: {
                                value: _vm.formData.bankAccountNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "bankAccountNumber",
                                    $$v
                                  )
                                },
                                expression: "formData.bankAccountNumber"
                              }
                            }),
                            _vm.$validator.errors.has("bankAccountNumber")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "bankAccountNumber"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "totalAmount" } }, [
                              _vm._v(
                                " Monto total de la contratación" +
                                  _vm._s(
                                    _vm.isNotDocenteForm ? " (BRUTO)" : ""
                                  ) +
                                  " "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.required("totalAmount"))
                                }
                              })
                            ]),
                            _c("input-currency", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-0",
                              attrs: {
                                label: "",
                                options: _vm.currencyInputOptions,
                                disabled: true,
                                "data-cy": "totalAmount",
                                name: "totalAmount",
                                "data-vv-as": "monto total de la contratación",
                                placeholder: _vm.isDocenteForm
                                  ? "Resultado de los datos anteriores..."
                                  : "Monto total de la contratación...",
                                state: _vm.$validator.errors.has("totalAmount")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "totalAmount"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "totalAmount"
                                )
                              },
                              on: { input: _vm.log },
                              model: {
                                value: _vm.formData.totalAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "totalAmount", $$v)
                                },
                                expression: "formData.totalAmount"
                              }
                            }),
                            _vm.$validator.errors.has("totalAmount")
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "totalAmount"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "paymentPeriod" } }, [
                              _vm._v(" Periodo de pago "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.required("paymentPeriod")
                                  )
                                }
                              }),
                              _c("br"),
                              _c("span", { staticClass: "text-xs mt-1" }, [
                                _vm._v(
                                  " (En fecha establecida por la Universidad para el pago de honorarios) "
                                )
                              ])
                            ]),
                            _c("v-select-payment-period", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "paymentPeriod",
                                "data-cy": "paymentPeriod",
                                "data-vv-as": "periodo de pago",
                                state: _vm.$validator.errors.has(
                                  "paymentPeriod"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "paymentPeriod"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "paymentPeriod"
                                )
                              },
                              model: {
                                value: _vm.formData.paymentPeriod,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "paymentPeriod", $$v)
                                },
                                expression: "formData.paymentPeriod"
                              }
                            }),
                            _vm.$validator.errors.has("paymentPeriod")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "paymentPeriod"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "contractPaymentPeriod" } },
                              [
                                _vm._v(
                                  " Periodicidad del pago de la contratación "
                                ),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.required("contractPaymentPeriod")
                                    )
                                  }
                                })
                              ]
                            ),
                            _c("v-select-contract-payment-period", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                parent: _vm.$vnode,
                                name: "contractPaymentPeriod",
                                "data-cy": "contractPaymentPeriod",
                                "data-vv-as":
                                  "periodicidad del pago de la contratación",
                                state: _vm.$validator.errors.has(
                                  "contractPaymentPeriod"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "contractPaymentPeriod"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "contractPaymentPeriod"
                                )
                              },
                              model: {
                                value: _vm.formData.contractPaymentPeriod,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "contractPaymentPeriod",
                                    $$v
                                  )
                                },
                                expression: "formData.contractPaymentPeriod"
                              }
                            }),
                            _vm.$validator.errors.has("contractPaymentPeriod")
                              ? _c("v-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$validator.errors.first(
                                          "contractPaymentPeriod"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    !_vm.isDocenteForm
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "serviceExpenseClassification"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Clasificación del gasto (solo para proyecto) "
                                    ),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required(
                                            "serviceExpenseClassification"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("select-options", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "serviceExpenseClassification",
                                    "options-group":
                                      "fisabs-service-expense-classification",
                                    "data-cy": "service-expense-classification",
                                    "alphabetical-sort": true,
                                    "data-vv-as":
                                      "clasificación del gasto (solo para proyecto)",
                                    state: _vm.$validator.errors.has(
                                      "serviceExpenseClassification"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "serviceExpenseClassification"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "serviceExpenseClassification"
                                    ),
                                    "filter-by-doc-type": _vm.DOCUMENT_TYPE.SCH
                                  },
                                  model: {
                                    value:
                                      _vm.formData.serviceExpenseClassification,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "serviceExpenseClassification",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.serviceExpenseClassification"
                                  }
                                }),
                                _vm.$validator.errors.has(
                                  "serviceExpenseClassification"
                                )
                                  ? _c("v-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "serviceExpenseClassification"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "serviceProjectObjective" } },
                              [_vm._v(" Objetivo del proyecto ")]
                            ),
                            _c("b-form-input", {
                              attrs: {
                                "data-cy": "serviceProjectObjective",
                                name: "serviceProjectObjective",
                                "data-vv-as": "objetivo del proyecto",
                                placeholder: "Ingrese el objetivo del proyecto",
                                state: _vm.$validator.errors.has(
                                  "serviceProjectObjective"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "serviceProjectObjective"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "serviceProjectObjective"
                                )
                              },
                              model: {
                                value: _vm.formData.serviceProjectObjective,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "serviceProjectObjective",
                                    $$v
                                  )
                                },
                                expression: "formData.serviceProjectObjective"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "serviceResult" } }, [
                              _vm._v(
                                " Resultado / Hito / Actividad principal / Indicador "
                              )
                            ]),
                            _c("b-form-input", {
                              attrs: {
                                "data-cy": "serviceResult",
                                name: "serviceResult",
                                "data-vv-as":
                                  "Resultado / Hito / Actividad principal / Indicador",
                                placeholder:
                                  "Ingrese el resultado/hito/actividad principal/indicador",
                                state: _vm.$validator.errors.has(
                                  "serviceResult"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "serviceResult"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "serviceResult"
                                )
                              },
                              model: {
                                value: _vm.formData.serviceResult,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "serviceResult", $$v)
                                },
                                expression: "formData.serviceResult"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "serviceExpenseCode" } },
                              [
                                _vm._v(
                                  " Código del gasto en el plan de gastos del proyecto "
                                )
                              ]
                            ),
                            _c("b-form-input", {
                              attrs: {
                                "data-cy": "serviceExpenseCode",
                                name: "serviceExpenseCode",
                                "data-vv-as":
                                  "código del gasto en el plan de gastos del proyecto",
                                placeholder:
                                  "Ingrese el código del gasto en el plan de gastos del proyecto",
                                state: _vm.$validator.errors.has(
                                  "serviceExpenseCode"
                                )
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has(
                                  "serviceExpenseCode"
                                ),
                                "danger-text": _vm.$validator.errors.first(
                                  "serviceExpenseCode"
                                )
                              },
                              model: {
                                value: _vm.formData.serviceExpenseCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "serviceExpenseCode",
                                    $$v
                                  )
                                },
                                expression: "formData.serviceExpenseCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 mt-5" },
                      [
                        _c("vs-table", {
                          staticClass: "wrap-table shadow",
                          attrs: {
                            hoverFlat: "",
                            data: _vm.formData.paymentPeriodBreakdown || [],
                            noDataText: "No hay actividades aún"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var data = ref.data
                                  return [
                                    _c("thead", [
                                      _c("th", { staticClass: "text-center" }, [
                                        _vm._v(" Desglose del periodo de pago ")
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(data, function(_, idx) {
                                        return _c(
                                          "vs-tr",
                                          { key: idx },
                                          [
                                            _c(
                                              "vs-td",
                                              {
                                                staticClass: "table-part",
                                                attrs: { data: data[idx] }
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    ref:
                                                      "paymentPeriodBreakdown[" +
                                                      idx +
                                                      "].row",
                                                    refInFor: true,
                                                    staticClass:
                                                      "border mx-1 my-2 py-4"
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].description"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Descripción "
                                                                ),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.required(
                                                                        "paymentPeriodBreakdown[" +
                                                                          idx +
                                                                          "].description"
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _c("b-form-input", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              attrs: {
                                                                name:
                                                                  "paymentPeriodBreakdown[" +
                                                                  idx +
                                                                  "].description",
                                                                "data-cy":
                                                                  "paymentPeriodBreakdown[" +
                                                                  idx +
                                                                  "].description",
                                                                "data-vv-as":
                                                                  "descripción",
                                                                placeholder:
                                                                  "Descripción...",
                                                                state: _vm.$validator.errors.has(
                                                                  "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].description"
                                                                )
                                                                  ? false
                                                                  : null,
                                                                danger: _vm.$validator.errors.has(
                                                                  "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].description"
                                                                ),
                                                                "danger-text": _vm.$validator.errors.first(
                                                                  "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].description"
                                                                )
                                                              },
                                                              model: {
                                                                value:
                                                                  data[idx]
                                                                    .description,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    data[idx],
                                                                    "description",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "data[idx].description"
                                                              }
                                                            }),
                                                            _vm.$validator.errors.has(
                                                              "paymentPeriodBreakdown[" +
                                                                idx +
                                                                "].description"
                                                            )
                                                              ? _c(
                                                                  "b-form-invalid-feedback",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$validator.errors.first(
                                                                            "paymentPeriodBreakdown[" +
                                                                              idx +
                                                                              "].description"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].amount"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Monto bruto "
                                                                ),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.required(
                                                                        "paymentPeriodBreakdown[" +
                                                                          idx +
                                                                          "].amount"
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _c(
                                                              "input-currency",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "required|min_value:1",
                                                                    expression:
                                                                      "'required|min_value:1'"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "mb-0",
                                                                attrs: {
                                                                  label: "",
                                                                  options:
                                                                    _vm.currencyInputOptions,
                                                                  name:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].amount",
                                                                  "data-cy":
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].amount",
                                                                  "data-vv-as":
                                                                    "monto bruto",
                                                                  placeholder:
                                                                    "Monto bruto...",
                                                                  state: _vm.$validator.errors.has(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].amount"
                                                                  )
                                                                    ? false
                                                                    : null,
                                                                  danger: _vm.$validator.errors.has(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].amount"
                                                                  ),
                                                                  "danger-text": _vm.$validator.errors.first(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].amount"
                                                                  )
                                                                },
                                                                on: {
                                                                  input:
                                                                    _vm.validateTotalAmount
                                                                },
                                                                model: {
                                                                  value:
                                                                    data[idx]
                                                                      .amount,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      data[idx],
                                                                      "amount",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "data[idx].amount"
                                                                }
                                                              }
                                                            ),
                                                            _vm.$validator.errors.has(
                                                              "paymentPeriodBreakdown[" +
                                                                idx +
                                                                "].amount"
                                                            )
                                                              ? _c(
                                                                  "b-form-invalid-feedback",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$validator.errors.first(
                                                                            "paymentPeriodBreakdown[" +
                                                                              idx +
                                                                              "].amount"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].project"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Fuente de Financiamiento "
                                                                ),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.required(
                                                                        "paymentPeriodBreakdown[" +
                                                                          idx +
                                                                          "].project"
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _c(
                                                              "select-options",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "required",
                                                                    expression:
                                                                      "'required'"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  name:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].project",
                                                                  "options-group":
                                                                    "fisabs-service-funding-source",
                                                                  "data-vv-as":
                                                                    "fuente de financiamiento",
                                                                  "data-cy":
                                                                    "`paymentPeriodBreakdown[${idx}].project`"
                                                                },
                                                                model: {
                                                                  value:
                                                                    data[idx]
                                                                      .project,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      data[idx],
                                                                      "project",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "data[idx].project"
                                                                }
                                                              }
                                                            ),
                                                            _vm.$validator.errors.has(
                                                              "paymentPeriodBreakdown[" +
                                                                idx +
                                                                "].project"
                                                            )
                                                              ? _c(
                                                                  "b-form-invalid-feedback",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$validator.errors.first(
                                                                            "paymentPeriodBreakdown[" +
                                                                              idx +
                                                                              "].project"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].responsibilityCenter"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Centro de responsabilidad "
                                                                ),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.required(
                                                                        "paymentPeriodBreakdown[" +
                                                                          idx +
                                                                          "].responsibilityCenter"
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-select-responsibility-center",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "required",
                                                                    expression:
                                                                      "'required'"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  parent:
                                                                    _vm.$vnode,
                                                                  name:
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].responsibilityCenter",
                                                                  "data-cy":
                                                                    "paymentPeriodBreakdown[" +
                                                                    idx +
                                                                    "].responsibilityCenter",
                                                                  "data-vv-as":
                                                                    "centro de responsabilidad",
                                                                  state: _vm.$validator.errors.has(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].responsibilityCenter"
                                                                  )
                                                                    ? false
                                                                    : null,
                                                                  danger: _vm.$validator.errors.has(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].responsibilityCenter"
                                                                  ),
                                                                  "danger-text": _vm.$validator.errors.first(
                                                                    "paymentPeriodBreakdown[" +
                                                                      idx +
                                                                      "].responsibilityCenter"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    data[idx]
                                                                      .responsibilityCenter,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      data[idx],
                                                                      "responsibilityCenter",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "data[idx].responsibilityCenter"
                                                                }
                                                              }
                                                            ),
                                                            _vm.$validator.errors.has(
                                                              "paymentPeriodBreakdown[" +
                                                                idx +
                                                                "].responsibilityCenter"
                                                            )
                                                              ? _c(
                                                                  "v-invalid-feedback",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$validator.errors.first(
                                                                            "paymentPeriodBreakdown[" +
                                                                              idx +
                                                                              "].responsibilityCenter"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        attrs: {
                                                          cols:
                                                            "12 d-flex justify-content-end"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "vs-button",
                                                          {
                                                            attrs: {
                                                              color: "danger",
                                                              type: "border",
                                                              icon: "delete"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removePaymentPeriodBreakdownRow(
                                                                  idx
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Eliminar fila "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _vm.totalAmountError
                                                          ? _c(
                                                              "v-invalid-feedback",
                                                              {
                                                                attrs: {
                                                                  "data-cy":
                                                                    "totalAmountError"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.totalAmountError
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    ),
                                    _c(
                                      "tfoot",
                                      [
                                        _c(
                                          "vs-tr",
                                          [
                                            _c(
                                              "vs-td",
                                              { attrs: { colspan: "3" } },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      color: "primary",
                                                      type: "border",
                                                      icon: "add"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.addPaymentPeriodBreakdownRow
                                                    }
                                                  },
                                                  [_vm._v(" Agregar fila ")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2606310088
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(7),
                    _c(
                      "div",
                      { staticClass: "col-12 -mb-3 mt-3" },
                      [
                        _c("b-form-group", [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-8 align-content-center",
                                  attrs: { for: "travelAllowance" }
                                },
                                [
                                  _vm._v(" Derecho a Viáticos "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("travelAllowance")
                                      )
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-form-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "col-4",
                                  attrs: {
                                    "data-cy": "travelAllowance",
                                    name: "travelAllowance",
                                    "data-vv-as": "derecho a viáticos",
                                    state: _vm.$validator.errors.has(
                                      "travelAllowance"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "travelAllowance"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "travelAllowance"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.travelAllowance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "travelAllowance",
                                        $$v
                                      )
                                    },
                                    expression: "formData.travelAllowance"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: true } },
                                    [_vm._v("Sí")]
                                  ),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: false } },
                                    [_vm._v("No")]
                                  )
                                ],
                                1
                              ),
                              _vm.$validator.errors.has("travelAllowance")
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$validator.errors.first(
                                            "travelAllowance"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.formData.travelAllowance
                      ? _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "travelAllowanceJustification"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Justificación (derecho a viáticos) "
                                    ),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required(
                                            "travelAllowanceJustification"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.isTravelAllowanceJustificationRequired
                                      },
                                      expression:
                                        "{required: isTravelAllowanceJustificationRequired,}"
                                    }
                                  ],
                                  attrs: {
                                    "data-cy": "travelAllowanceJustification",
                                    name: "travelAllowanceJustification",
                                    "data-vv-as": "justificación",
                                    placeholder: "Justificación...",
                                    state: _vm.$validator.errors.has(
                                      "travelAllowanceJustification"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "travelAllowanceJustification"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "travelAllowanceJustification"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData.travelAllowanceJustification,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "travelAllowanceJustification",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.travelAllowanceJustification"
                                  }
                                }),
                                _vm.$validator.errors.has(
                                  "travelAllowanceJustification"
                                )
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "travelAllowanceJustification"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 -mb-3 mt-3" },
                      [
                        _c("b-form-group", [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-8 align-content-center",
                                  attrs: { for: "landPassageRefund" }
                                },
                                [
                                  _vm._v(
                                    " Reembolsos pasajes terrestres y/o combustible "
                                  ),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("landPassageRefund")
                                      )
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-form-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "col-4",
                                  attrs: {
                                    "data-cy": "landPassageRefund",
                                    name: "landPassageRefund",
                                    "data-vv-as":
                                      "reembolsos pasajes terrestres y/o combustible",
                                    state: _vm.$validator.errors.has(
                                      "landPassageRefund"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "landPassageRefund"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "landPassageRefund"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.landPassageRefund,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "landPassageRefund",
                                        $$v
                                      )
                                    },
                                    expression: "formData.landPassageRefund"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: true } },
                                    [_vm._v("Sí")]
                                  ),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: false } },
                                    [_vm._v("No")]
                                  )
                                ],
                                1
                              ),
                              _vm.$validator.errors.has("landPassageRefund")
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$validator.errors.first(
                                            "landPassageRefund"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.formData.landPassageRefund
                      ? _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "landPassageRefundJustification"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Justificación (reembolsos pasajes terrestres y/o combustible) "
                                    ),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required(
                                            "landPassageRefundJustification"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.isLandPassageRefundJustificationRequired
                                      },
                                      expression:
                                        "{ required: isLandPassageRefundJustificationRequired }"
                                    }
                                  ],
                                  attrs: {
                                    "data-cy": "landPassageRefundJustification",
                                    name: "landPassageRefundJustification",
                                    "data-vv-as": "justificación",
                                    placeholder: "Justificación...",
                                    state: _vm.$validator.errors.has(
                                      "landPassageRefundJustification"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "landPassageRefundJustification"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "landPassageRefundJustification"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData
                                        .landPassageRefundJustification,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "landPassageRefundJustification",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.landPassageRefundJustification"
                                  }
                                }),
                                _vm.$validator.errors.has(
                                  "landPassageRefundJustification"
                                )
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "landPassageRefundJustification"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 -mb-3 mt-3" },
                      [
                        _c("b-form-group", [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-8 align-content-center",
                                  attrs: { for: "training" }
                                },
                                [
                                  _vm._v(" Capacitaciones "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("training")
                                      )
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-form-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "col-4",
                                  attrs: {
                                    "data-cy": "training",
                                    name: "training",
                                    "data-vv-as": "capacitaciones",
                                    state: _vm.$validator.errors.has("training")
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "training"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "training"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.training,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "training", $$v)
                                    },
                                    expression: "formData.training"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: true } },
                                    [_vm._v("Sí")]
                                  ),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: false } },
                                    [_vm._v("No")]
                                  )
                                ],
                                1
                              ),
                              _vm.$validator.errors.has("training")
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$validator.errors.first(
                                            "training"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.formData.training
                      ? _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "trainingJustification" } },
                                  [
                                    _vm._v(" Justificación (capacitaciones) "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required("trainingJustification")
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.isTrainingJustificationRequired
                                      },
                                      expression:
                                        "{required: isTrainingJustificationRequired}"
                                    }
                                  ],
                                  attrs: {
                                    "data-cy": "trainingJustification",
                                    name: "trainingJustification",
                                    "data-vv-as": "justificación",
                                    placeholder: "Justificación...",
                                    state: _vm.$validator.errors.has(
                                      "trainingJustification"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "trainingJustification"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "trainingJustification"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.trainingJustification,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "trainingJustification",
                                        $$v
                                      )
                                    },
                                    expression: "formData.trainingJustification"
                                  }
                                }),
                                _vm.$validator.errors.has(
                                  "trainingJustification"
                                )
                                  ? _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "trainingJustification"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 -mb-3 mt-3" },
                      [
                        _c("b-form-group", [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-8 align-content-center",
                                  attrs: { for: "isPublicAgent" }
                                },
                                [
                                  _vm._v(" Agente Público "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.required("isPublicAgent")
                                      )
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-form-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "col-4",
                                  attrs: {
                                    "data-cy": "isPublicAgent",
                                    name: "isPublicAgent",
                                    "data-vv-as": "agente público",
                                    state: _vm.$validator.errors.has(
                                      "isPublicAgent"
                                    )
                                      ? false
                                      : null,
                                    danger: _vm.$validator.errors.has(
                                      "isPublicAgent"
                                    ),
                                    "danger-text": _vm.$validator.errors.first(
                                      "isPublicAgent"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.isPublicAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "isPublicAgent",
                                        $$v
                                      )
                                    },
                                    expression: "formData.isPublicAgent"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: true } },
                                    [_vm._v("Sí")]
                                  ),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: false } },
                                    [_vm._v("No")]
                                  )
                                ],
                                1
                              ),
                              _vm.$validator.errors.has("isPublicAgent")
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$validator.errors.first(
                                            "isPublicAgent"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 my-2" },
                      [_c("vs-divider")],
                      1
                    ),
                    _vm._m(8),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        !_vm.schAttachmentsSelectors.loading
                          ? _c("dynamic-file-selector", {
                              attrs: {
                                selectors: _vm.schAttachmentsSelectors.list
                                  .slice()
                                  .sort(function(a, b) {
                                    return a.order - b.order
                                  })
                                  .map(function(sel) {
                                    return Object.assign({}, sel, sel.extra, {
                                      index: sel.order
                                    })
                                  }),
                                "object-to-evaluate": _vm.formData,
                                files: _vm.dynamicSelectorFiles,
                                "reset-key": _vm.dfsResetKey
                              },
                              on: {
                                "update-files": _vm.updateFiles,
                                valid: function(valid) {
                                  _vm.dynamicFileSelectorValid = valid
                                }
                              }
                            })
                          : _c(
                              "div",
                              [
                                _c("b-skeleton", {
                                  attrs: { animation: "fade", width: "100%" }
                                }),
                                _c("b-skeleton", {
                                  attrs: { animation: "fade", width: "100%" }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          ),
          _c("vs-divider"),
          _vm._m(9),
          _c("form-action-buttons", {
            attrs: {
              saving: _vm.saving,
              preview: _vm.preview,
              back: _vm.back,
              save: _vm.save,
              saveDraft: _vm.saveDraft
            }
          }),
          _c("repository-selector", {
            attrs: {
              "modal-id": "add-repository-experience-file",
              "add-file": _vm.addExperienceFile,
              files: _vm.experienceFiles,
              "remove-file": _vm.removeExperienceFile,
              "max-files": _vm.maxExperienceFiles
            }
          }),
          _c("repository-selector", {
            attrs: {
              "modal-id": "add-repository-expertise-file",
              "add-file": _vm.addExpertiseFile,
              files: _vm.expertiseFiles,
              "remove-file": _vm.removeExpertiseFile,
              "max-files": _vm.maxExpertiseFiles
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-5" }, [
      _c("h4", [
        _vm._v(
          "DATOS DE LA PERSONA QUE SE SOLICITA SEA CONTRATADA A HONORARIOS"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("h5", [_vm._v("PERSONALES")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("h5", [_vm._v("EDUCACIONALES")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("h5", [_vm._v("PREVISIÓN Y SALUD")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("h5", [_vm._v("OTROS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("span", { staticClass: "text-primary" }, [
        _vm._v(
          " Los siguientes roles deben ser definidos por la persona solicitante al completar el formulario de solicitud de contratación de honorarios. Posteriormente, quienes ocupen estos roles participarán en el flujo de aprobación de los informes de actividades 2.0 "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("h5", [_vm._v("DATOS DE TRANSFERENCIA")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Indicar si el convenio contempla")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Documentos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-xs text-right" }, [
      _c("b", [
        _vm._v("Los campos marcados con "),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
        _vm._v(" son obligatorios")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }